import { render, staticRenderFns } from "./GenerateSerialVersionTwo.vue?vue&type=template&id=7772424f&"
import script from "./GenerateSerialVersionTwo.vue?vue&type=script&lang=js&"
export * from "./GenerateSerialVersionTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports